import React, { Suspense, useEffect, useRef, useState } from "react";
import Footer from "src/components/footer";
import { Outlet, useLocation } from "react-router";
import Breadcrumb from "../Breadcrumb";
import { ReactComponent as ChatIcon } from "src/assets/static/images/Chat.svg";
import { ReactComponent as PhoneIcon } from "src/assets/static/images/call-circle.svg";
import { ReactComponent as MessageIcon } from "src/assets/static/images/message-circle.svg";
import CurrentDeviceSize from "src/hooks/utils/currentDeviceSize";
import { ReactComponent as ChatIconMobile } from "src/assets/static/images/chat-mobile-icon.svg";
import ScrollToTop from "../ScrollToTop";
import useFormatById from "src/hooks/utils/useFormatById";
import CustomProgressBar from "../CustomProgressBar";
import Header from "src/components/header";

const PageLayout = () => {
  const navbarRef = useRef(null);
  const [showHoverBlock, setShowHoverBlock] = useState(false);
  const location = useLocation();
  const routeName = location?.pathname;
  const containerRef = useRef(null);
  const randomProgress = Math.floor(Math.random() * (70 - 54 + 1)) + 54;
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setShowHoverBlock(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const deviceSize = CurrentDeviceSize();
  const isMobile = deviceSize === "Mobile";
  const f = useFormatById();
  const currentProgressRef = useRef(randomProgress);

  useEffect(() => {
    const loadModule = async () => {
      await new Promise((resolve) => {
        const animateProgress = () => {
          const increment = Math.floor(Math.random() * 14) + 2;
          const newProgress = Math.min(
            100,
            currentProgressRef.current + increment
          );
          currentProgressRef.current = newProgress;

          if (newProgress < 100) {
            setTimeout(animateProgress, 200);
          } else {
            resolve();
          }
        };

        animateProgress();
      });
    };

    loadModule().then(() => {
      currentProgressRef.current = randomProgress;
    });
  }, [routeName]);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup scroll event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="main-project page-container">
        {/* <Topbar navbarRef={navbarRef} /> */}
        <Header navbarRef={navbarRef} />
        <Breadcrumb />
        <ScrollToTop />

        <div
          className={`chat-icon-container ${
            scrollPosition < 100 &&
            location.pathname.includes("home") &&
            !isMobile
              ? "bottom-of-hero"
              : ""
          }`}
          ref={containerRef}
        >
          {isMobile ? (
            <ChatIcon onClick={() => setShowHoverBlock((item) => !item)} />
          ) : (
            <ChatIcon onClick={() => setShowHoverBlock((item) => !item)} />
          )}
          {showHoverBlock && (
            <div className="hover-block">
              <div className="container">
                {/* <div className="col-12">
                  <a
                    href="https://webcall.imedil.ge/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <PhoneIcon className="me-2" />
                    {f("main.callUs")}
                  </a>
                </div> */}
                <div className="col-12">
                  {/* <hr /> */}
                  <a
                    href="http://contact.imedil.ge/login"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <MessageIcon className="me-2" /> {f("main.messageUs")}
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
        <main className="main-project main-content d-flex flex-column mb-5">
          <Suspense
            fallback={
              <CustomProgressBar progress={currentProgressRef.current} />
            }
          >
            <Outlet />
          </Suspense>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default PageLayout;
